<template>
  <div
    class="modal fade"
    id="detailsModal"
    tabindex="-1"
    aria-labelledby="detailsModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-rl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-title" id="detailsModalLabel">
            {{ t("expense_page.expense_details") }}
          </h5>
          <button
            type="button"
            class="btn-close p-0"
            data-bs-dismiss="modal"
            :aria-label="t('common.close')"
          >
            <img
              src="../../../assets/img/icons/close-circle-2.svg"
              :alt="t('common.close')"
            />
          </button>
        </div>
        <div class="modal-body" v-if="expense">
          <ul class="details-title list-style mb-40">
            <li class="fs-14 fw-medium text-title lh-1">
              {{ t("expense_page.date") }} :<span class="fw-semibold ms-1">{{ formatDateTime(expense.date) }}</span>
            </li>
            <li class="fs-14 fw-medium text-title lh-1">
              {{ t("expense_page.reference") }} :<span class="fw-semibold ms-1">{{ expense.referenceno || t("expense_page.not_available") }}</span>
            </li>
          </ul>
          
          <div class="table-responsive style-two mb-25">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-title fw-normal fs-14 lh-1">{{ t("expense_page.no_short") }}</th>
                  <th scope="col" class="text-title fw-normal fs-14 lh-1">{{ t("expense_page.category") }}</th>
                  <th scope="col" class="text-title fw-normal fs-14 lh-1">{{ t("expense_page.warehouse") }}</th>
                  <th scope="col" class="text-title fw-normal fs-14 lh-1">{{ t("expense_page.amount") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">01</td>
                  <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                    {{ expense.category?.name || expense.category_name || t("expense_page.not_available") }}
                  </td>
                  <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                    {{ expense.warehouse?.name || t("expense_page.not_available") }}
                  </td>
                  <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                    ${{ Number(expense.amount).toFixed(2) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-group mb-25">
            <label class="d-block fs-14 text-black mb-2">{{ t("expense_page.description") }}</label>
            <p class="fs-14 text-paragraph lh-base">
              {{ expense.description || t("expense_page.no_description_available") }}
            </p>
          </div>
        </div>
        <div class="modal-body" v-else>
            <p class="text-center">{{ t("expense_page.no_expense_selected") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "DetailsModal",
  props: {
    expense: {
      type: Object as PropType<any>,
      default: null,
    },
  },
  setup() {
    const { t, locale } = useI18n();

    const formatDateTime = (value?: string) => {
      if (!value) return t("expense_page.not_available");

      return new Date(value).toLocaleString(locale.value === "km" ? "km-KH" : "en-GB", {
        timeZone: "Asia/Phnom_Penh",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    };

    return {
      formatDateTime,
      t,
    };
  },
});
</script>
